import { all } from 'redux-saga/effects';
import sessionsSaga from 'sagas/sessionsSaga';
import companySaga from 'sagas/companiesSaga';

export default function* rootSaga() {
  yield all([...sessionsSaga, ...companySaga]);
}
